// extracted by mini-css-extract-plugin
module.exports = {"rotation":"NewsletterTemplate_rotation__GcNn2"};